import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const { baseApi } = apiPrefix;
const adminApi = `${baseApi}/officialArticle/admin`;

// 获取文章列表
export const getArticleList = (params) => post(`${adminApi}/list`, params);
// 获取文章分类选项
export const getArticleTypes = () => get(`${adminApi}/types`);
// 获取文章详情
export const getArticleDetail = (params) => get(`${adminApi}/detail`, params);
// 创建文章
export const createArticle = (params) => post(`${adminApi}/create`, params);
// 修改文章
export const updateArticle = (params) => post(`${adminApi}/update`, params);
// 发布文章
export const publishArticle = ({id, ...params}) => post(`${adminApi}/publish?id=${id}`, params);
// 下架文章
export const offlineArticle = ({id, ...params}) => post(`${adminApi}/offline?id=${id}`, params);
//  上传文章图片
export const uploadArticleImage = (params) => post(`${baseApi}/landPageTemplate/uploadFile`, params, { isFormData: true });
